import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 17H20V7H4V17ZM4 19C3.45 19 2.97933 18.8043 2.588 18.413C2.196 18.021 2 17.55 2 17V7C2 6.45 2.196 5.97933 2.588 5.588C2.97933 5.196 3.45 5 4 5H20C20.55 5 21.021 5.196 21.413 5.588C21.8043 5.97933 22 6.45 22 7V17C22 17.55 21.8043 18.021 21.413 18.413C21.021 18.8043 20.55 19 20 19H4ZM11 10H13V8H11V10ZM11 13H13V11H11V13ZM8 10H10V8H8V10ZM8 13H10V11H8V13ZM5 13H7V11H5V13ZM5 10H7V8H5V10ZM9 16H15C15.2833 16 15.521 15.904 15.713 15.712C15.9043 15.5207 16 15.2833 16 15C16 14.7167 15.9043 14.479 15.713 14.287C15.521 14.0957 15.2833 14 15 14H9C8.71667 14 8.47933 14.0957 8.288 14.287C8.096 14.479 8 14.7167 8 15C8 15.2833 8.096 15.5207 8.288 15.712C8.47933 15.904 8.71667 16 9 16ZM14 13H16V11H14V13ZM14 10H16V8H14V10ZM17 13H19V11H17V13ZM17 10H19V8H17V10Z",
		fill: "currentColor"
	})
});
export default SvgKeyboard;
